var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnFaceBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a052e101-81b0-42de-a099-c18c31e80271",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .ea06baef-9b9a-4a1d-9b50-2237cbe7ef32 {\r\n        fill: #ccc;\r\n      }\r\n\r\n      .a5a0b5fa-6b06-40b0-99d5-b11719564c33 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "ea06baef-9b9a-4a1d-9b50-2237cbe7ef32",
    width: 45,
    height: 45,
    rx: 7.101
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5a0b5fa-6b06-40b0-99d5-b11719564c33",
    d: "M35.886,27.366l.948-7.2H29.971v-5a2.53,2.53,0,0,1,2.529-2.53h4.446V6.161H30.733a7.961,7.961,0,0,0-7.961,7.961v6.045H16.829v7.2h5.943V45h7.2V27.366Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnFaceBook);
export default __webpack_public_path__ + "static/media/bnFaceBook.458371d470980aee6b9be2ea11fe6c3e.svg";
export { ForwardRef as ReactComponent };